import { Row, Col, Media, Image } from 'react-bootstrap'
import {  FaGift } from 'react-icons/fa'
import Link from 'next/link'
import { Request } from '@group-devs/yfp7-global-modules'

const request = new Request(process.env.apiDomain)

function LoyaltyStrip(props) {
    const site = props.props.site

    const { data: profile  } = request.account.swrAccountProfile(site.accountId)
    const { data: shaklee } = request.account.swrShakleeInfo(site.accountId, profile ? profile.user.id : profile)

    const data =[
        {
            title:"Loyalty Rewards Program", desc:"Exciting benefits await you when you purchase Shaklee’s wellness products consistently!", 
            image:"../images/dashboard/img-earn-free-products01.svg", 
            url: `${shaklee ? 'https://us.shaklee.com/loyaltyrewards?pwsName='+shaklee.shaklee_pws_name+'' : '' }`, 
            class:"span-left"
        }
       
    ]

     {/*{title:"Earn FREE Products!", desc:"Increase your wellness IQ and earn free products by reviewing some of our best wellness content .", image:"../images/test/free.png", url:"/learn-and-earn/overview", class:"span-right"},*/}

    return (
        <>
            <Row className="my-5 py-3 mx-lg-5 px-lg-5">
                {data.map((data,idx) => (
                    <Col md={6} key={idx} className="h7 mb-md-0 mb-5">
                        <Media>
                            <Image src={data.image} width={60} className="mr-3" alt={data.title}/>
                            <Media.Body>
                                <h5 className="h6"><strong>{data.title}</strong></h5>
                                <p className="h7 desc">{data.desc}</p>
                                <Link href={data.url}><a className="border-green border text-reset px-4 py-1 d-inline-block btn-trans-green">Learn more</a></Link>
                            </Media.Body>
                        </Media>
                    </Col>
                ))}
            </Row>
            <style jsx>
                {`
                    .desc{
                        max-width:300px;
                    }
                    span{
                        width: 50px;
                        height: 50px;
                    }
                    .span-left{
                        padding: 10px;
                    }
                    .span-right{
                        padding: 15px 10px;
                        font-size: 1rem;
                    }
                `}
            </style>
        </>
    )
}

export default LoyaltyStrip
